(function ($) {

  const initializeBlock = function ($block) {
    const affiliatedStates = window.states
    const telehealthLocations = window.telehealth_locations

    // HANDLE STATES
    const uniqueStates = [
      ...new Set(
        Object.values(affiliatedStates)
          .map(item => item.slug)
          .filter(Boolean)
      )
    ];
    for (let i = 0; i < uniqueStates.length; i++) {
      $block.find('path.' + uniqueStates[i]).addClass('affiliated')
    }

    // HANDLE TELEHEALTH
    const uniqueTelehealth = [
      ...new Set(
        Object.values(telehealthLocations)
          .map(item => item.slug)
          .filter(Boolean)
      )
    ];
    for (let i = 0; i < uniqueTelehealth.length; i++) {
      $block.find('path.' + uniqueTelehealth[i]).addClass('telehealth')
    }

    $('.affiliated.telehealth').addClass('both');
  }

  $(document).ready(function () {
    $('.block--locations').each(function () {
      initializeBlock($(this));
    })
  })

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=locations', initializeBlock);
  }

})(jQuery);
